import BookingForm from './BookingForm.vue'
import Thank from './Thank.vue'
import CalendarBooking from './CalendarBooking.vue'
import BookingFormEmp from './BookingFormEmp.vue'
import CalendarBookingEmp from './CalendarBookingEmp.vue'
import BookingMain from './BookingMain.vue'
import BookingHistory from './BookingHistory.vue'

export default {
  BookingMain,
  CalendarBooking,
  CalendarBookingEmp,
  BookingForm,
  BookingFormEmp,
  BookingHistory,
  Thank
}



// WEBPACK FOOTER //
// ./src/components/ChatMe/index.js